import { render } from "./AllResultsWrapperMobile.vue?vue&type=template&id=67cbd636&scoped=true"
import script from "./AllResultsWrapperMobile.vue?vue&type=script&lang=js"
export * from "./AllResultsWrapperMobile.vue?vue&type=script&lang=js"

import "./AllResultsWrapperMobile.vue?vue&type=style&index=0&id=67cbd636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cbd636"]])

export default __exports__